"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_meeting_dto_1 = require("./dto/create-meeting.dto");
const get_meetings_dto_1 = require("./dto/get-meetings.dto");
const update_meeting_dto_1 = require("./dto/update-meeting.dto");
const meeting_service_1 = require("./meeting.service");
const meeting_swagger_1 = require("./meeting.swagger");
let MeetingController = class MeetingController {
    constructor(meetingService) {
        this.meetingService = meetingService;
    }
    // Create a new meeting
    async createMeeting(meetingData, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            meetingData.createdBy = userId;
            meetingData.updatedBy = userId;
            const meeting = await this.meetingService.createMeeting(meetingData);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.meetingCreation, meeting));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.meetingNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.meetingCreationFailed);
        }
    }
    // Get all meetings with pagination, search, and sorting
    async getMeetings(query, res, req) {
        try {
            const { page, limit, search, sort, searchBy } = query;
            const userId = parseInt(req?.headers?.userid);
            const meetings = await this.meetingService.getMeetings(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sort || "createdAt:DESC", userId, searchBy || "");
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.meetingList, meetings));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message, messages_1.infoMessages.forBidden, messages_1.errorMessages.meetingListRetrievalFailed);
        }
    }
    // Get a meeting by ID
    async getMeetingById(id, res) {
        try {
            const meeting = await this.meetingService.getMeetingById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.meetingDetails, meeting));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.meetingNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.meetingDetailsRetrievalFailed);
        }
    }
    // Update a meeting by ID
    async updateMeetingById(id, updateMeeting, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            updateMeeting.updatedBy = userId;
            const meeting = await this.meetingService.updateMeeting(id, updateMeeting);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.meetingUpdated, meeting));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.meetingNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.meetingUpdateFailed);
        }
    }
    // Delete a meeting by ID
    async deleteMeetingById(id, res) {
        try {
            await this.meetingService.deleteMeetingById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.meetingDeleted));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.meetingNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.meetingDeletionFailed);
        }
    }
    async getMeetingsByOpportunityAndActivity(opportunityActivityId, res) {
        try {
            const meetings = await this.meetingService.getMeetingsByOpportunityAndActivity(opportunityActivityId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.meetingList, meetings));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.meetingNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.failedToFetchMeetings);
        }
    }
};
exports.MeetingController = MeetingController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, meeting_swagger_1.createMeetingSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof create_meeting_dto_1.CreateMeetingDto !== "undefined" && create_meeting_dto_1.CreateMeetingDto) === "function" ? _b : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "createMeeting", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, meeting_swagger_1.getMeetingsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof get_meetings_dto_1.GetMeetingsDto !== "undefined" && get_meetings_dto_1.GetMeetingsDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "getMeetings", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, meeting_swagger_1.getMeetingByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "getMeetingById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, meeting_swagger_1.updateMeetingSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_d = typeof update_meeting_dto_1.UpdateMeetingDto !== "undefined" && update_meeting_dto_1.UpdateMeetingDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "updateMeetingById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, meeting_swagger_1.deleteMeetingSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "deleteMeetingById", null);
tslib_1.__decorate([
    (0, common_1.Get)("opportunity-activity/:opportunityActivityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityActivityId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], MeetingController.prototype, "getMeetingsByOpportunityAndActivity", null);
exports.MeetingController = MeetingController = tslib_1.__decorate([
    (0, common_1.Controller)("meeting"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof meeting_service_1.MeetingService !== "undefined" && meeting_service_1.MeetingService) === "function" ? _a : Object])
], MeetingController);
